import script from "./AppAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./AppAnnouncements.vue?vue&type=style&index=0&id=43fd5ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43fd5ef8"]])

export default __exports__